export default __webpack_public_path__ + "static/ThumbnailContent-93483553b94e1c99b6c679dbfa085a23.jpg";